import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'couponState',
})
export class CouponStatePipe implements PipeTransform {
  transform(value: string): string {
    return (
      {
        notStarted: '未开始',
        unused: '未使用',
        expire: '已过期',
        lock: '已锁定',
        haveUsed: '已使用',
      }[value] || value
    );
  }
}
